import React from "react";
import {NavDropdown} from "react-bootstrap";
import {SettingsService} from "../services/SettingsService";
import {getContainer} from "../ioc/IOCSetup";
import {Currency, Settings} from "../http/protocol";
import {LoadingViewState, RouterView} from "./RouterView";
import {RouteComponentProps, withRouter} from "react-router";


interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    currencies: Currency[];
    activeCurrency: string;
}

export class CurrencySelector extends RouterView<Props, State> {

    settingsService: SettingsService;
    constructor(props:Props) {
        super(props);

        this.settingsService = getContainer().getSettingsService();

        this.state = {currencies : [], activeCurrency: ""};
    }

    loadContent(): void {
        let localStorageActiveCurrency = window.localStorage.activeCurrency ? window.localStorage.activeCurrency:  "";

        this.settingsService.getSettings().then((data:Settings) => {
            let currencies: Currency[] = data.currencies ? data.currencies : [];
            this.setState({currencies: currencies, activeCurrency: localStorageActiveCurrency});
        });
    }

    onClick(currency:any) {
        if(currency) {
            window.localStorage.setItem("activeCurrency", currency);
            this.setState({activeCurrency : currency});
            console.log("Deleting cache Dashboard" + new Date().toISOString());
            localStorage.removeItem("dailyLogin");
            localStorage.removeItem("dailyRevenue");
            localStorage.removeItem("monthlyRevenue");
            localStorage.removeItem("lastMonthRevenue");
            localStorage.removeItem("dailyDeposit");
            localStorage.removeItem("dailyLoginGraphData");
            localStorage.removeItem("pendingWithdrawsResponse");
            localStorage.removeItem("failedPaymentsResponse");
            localStorage.removeItem("settings");
            localStorage.removeItem("internalSettings");
            localStorage.removeItem("errorEventsResponse");
            localStorage.removeItem("revenuePoker");
            localStorage.removeItem("revenueCasino");
            localStorage.removeItem("revenueSportbook");
            
            window.location.reload();
        }

    }
    getCurrencies() {
        if( this.state && this.state.currencies == null && this.state.activeCurrency == null) {
            return "";
        } else {
            
            let currencyFormatted = this.state.currencies.map((currency:Currency) => {
                if(currency) {
                    let curr:string = currency && currency.code ? currency.code : "";
                    return <NavDropdown.Item key={curr} onClick={() => (this.onClick(curr))} active={curr === (this.state.activeCurrency &&this.state.activeCurrency)}>{curr}</NavDropdown.Item>
                }
                return "";
            });

            return currencyFormatted;
        }
    }

    getTitle(): string {
        return "";
    }

    renderContent() {
        return(
            <div>
                <NavDropdown id={"currency-selector"} title={"Change Currency"}>
                    {this.getCurrencies()}
                </NavDropdown>
            </div>
        )
    }
}


export default withRouter(CurrencySelector);